import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card11 from "../Images/Profiles/Carol.jpg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function CarolGabeya() {
  return (
    <div className="ne-page">
      <SEO
        title="Ms. Caroline Gabeya - Office Administrator"
        description="Ms. Caroline Gabeya is a dedicated community worker with a Bachelor's degree in Adult and Community Education from Makerere University and a certificate in training trainers. Her research focuses on monitoring and evaluation of clean cooking stoves, biogas technology, behavioral change interventions, and innovative marketing strategies for cookstoves."
        keywords="Caroline Gabeya, Office Administrator, CIRCODU, Makerere University, training trainers, monitoring and evaluation, clean cooking stoves, biogas technology, behavioral change interventions, marketing strategies"
        url="/caroline-gabeya"
        image={Card11}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Ms. Caroline Gabeya</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/the-staff-team">
              The Staff Team
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Ms. Caroline Gabeya
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card11} alt="Ms. Caroline Gabeya" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Ms. Caroline Gabeya</h1>
                <p className="profile-card__role">Office Administrator</p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Ms. Gabeya Caroline, a dedicated community worker, holds a
                  Bachelor's degree in Adult and Community Education from
                  Makerere University and possesses a certificate in training
                  trainers. Her extensive research endeavors have revolved
                  around critical areas, including monitoring and evaluation of
                  clean cooking stoves, the utilization of biogas technology,
                  implementing behavioral change interventions to promote
                  cookstove adoption, and exploring innovative marketing and
                  distribution strategies for cookstoves.
                </p>
                <p>
                  Caroline's active engagement in CIRCODU's initiatives has
                  positioned her as one of the most proficient and seasoned
                  enumerators in the realm of monitoring and evaluation within
                  Uganda and East Africa. Her wealth of experience extends to
                  conducting third-party monitoring and evaluation activities
                  across a spectrum of projects, adapting seamlessly to the
                  diverse cultural landscapes of Uganda and other countries,
                  including Tanzania.
                </p>
                <p>
                  Furthermore, she has made valuable contributions by imparting
                  her knowledge and expertise through Training of Trainers
                  sessions in the production of Bio briquettes, further
                  cementing her role as a key player in the promotion of
                  sustainable and cleaner energy solutions.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/CIRCODU1/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/Gabbi.carolyne?mibextid=ZbWKwL/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256703436196"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:carol.gabeya@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CarolGabeya;
